import { useMemo } from 'react';
import { prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { TFormFieldText } from 'js/components/common/Form/types';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';

import { useDynamicReducerSelector } from '../store';

export const useURLSearchValues = () => {
    const { search } = useLocation();
    const fields = useDynamicReducerSelector(prop('fields'));

    return useMemo((): Record<string, string> => {
        const params = new URLSearchParams(search);

        return fields
            .filter(field => field.type === FORM_FIELD_TYPE.TEXT)
            .reduce((acc: Record<string, string>, field: TFormFieldText) => {
                const paramValue = params.get(field.urlQueryParameter);

                if (paramValue) {
                    Object.assign(acc, {
                        [field.name]: paramValue
                    });
                }

                return acc;
            }, {});
    }, [fields, search]);
};
